import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { searchDatasets } from '~modules/search/api';
import type { DatasetSearchResponse } from '~modules/search/types';

const PAGE_SIZE = 10;

export interface UseDatasetSearchArgs {
  query: string;
  page: number;
}

export function useDatasetSearch({
  query,
  page,
}: UseDatasetSearchArgs): UseQueryResult<DatasetSearchResponse> {
  return useQuery({
    queryKey: ['datasets', 'search', { query, page, limit: PAGE_SIZE }],
    queryFn: ({ signal }) =>
      searchDatasets({ query, page, limit: PAGE_SIZE, signal }),
    enabled: query.length > 0,
  });
}

export { PAGE_SIZE };
